import apiClient from './apiClient';

const normalizeIncident = (i) => ({ ...i, severity: String(i?.severity || 'MEDIUM').toLowerCase(), status: String(i?.status || 'OPEN').toLowerCase(), assignedTo: i?.assignedTo ?? i?.assignedToUserId ?? null });
const toIncidentPayload = (p) => ({ ...p, ...(p.severity != null && { severity: String(p.severity).toUpperCase() }), ...(p.status != null && { status: String(p.status).toUpperCase() }) });

export async function fetchIncidents() {
  const { data } = await apiClient.get('/incidents');
  return data.map(normalizeIncident);
}

export async function raiseIncident(payload) {
  const { data } = await apiClient.post('/incidents', toIncidentPayload(payload));
  return normalizeIncident(data);
}

export async function patchIncident(id, changes) {
  const { data } = await apiClient.patch(`/incidents/${id}`, toIncidentPayload(changes));
  return normalizeIncident(data);
}

export async function confirmIncidentContainment(id, evidence) {
  const { data } = await apiClient.post(`/incidents/${id}/confirm-containment`, { evidence });
  return normalizeIncident(data);
}
